const initialState = "0"; // "0" signifie "Tout"

function selectedResidenceReducer(state = initialState, action) {
  switch (action.type) {
    case "selectedResidence/update":
      return action.payload;
    default:
      return state;
  }
}

export default selectedResidenceReducer;
